@if (!isLoading) {
  <div class="main-container" data-cy="ar-payment-invoice-generator">
    @if (patientMode) {
      <div class="patient-action-container" data-cy="ar-payment-invoice-generator-patient-actions">
        @if (!isPaid) {
          <button mat-raised-button color="primary" class="action-button" (click)="payInvoice()" data-cy="ar-payment-invoice-generator-pay-btn">Pay
          invoice</button>
        }
        <button mat-raised-button color="primary" class="action-button" [disabled]="generatingPdf"
          (click)="generatePDF()" data-cy="ar-payment-invoice-generator-pdf-btn"><i class="material-icons">picture_as_pdf</i></button>
          <button mat-raised-button color="primary" class="action-button" (click)="close()" data-cy="ar-payment-invoice-generator-done-btn">Done</button>
        </div>
      }
      <div class="sub-container" data-cy="ar-payment-invoice-generator-sub-container">
        <div class="invoice-container" id="invoice-print-container" data-cy="ar-payment-invoice-generator-invoice-container">
          <div class="invoice-header-container" data-cy="ar-payment-invoice-generator-header-container">
            <div class="invoice-header" data-cy="ar-payment-invoice-generator-header">
              {{ dataInvoiceItem.title }}
            </div>
            @if (dataInvoiceItem.showImage) {
              <div class="invoice-image-container" data-cy="ar-payment-invoice-generator-image-container">
                <img class="invoice-image" alt="Practice Logo" src="https://tdoxfilestore.blob.core.windows.net/testing/practice-logo2.png" data-cy="ar-payment-invoice-generator-logo" />
              </div>
            }
          </div>
          <mat-divider data-cy="ar-payment-invoice-generator-divider-1"></mat-divider>
          <div class="invoice-sub-header" data-cy="ar-payment-invoice-generator-subheader">
            <div class="date-field" data-cy="ar-payment-invoice-generator-date-field">
              <div class="date-header" data-cy="ar-payment-invoice-generator-date-label">Date: </div>
              <div class="date-data" data-cy="ar-payment-invoice-generator-date-value">{{ dataInvoiceItem.invoiceDate | date }} </div>
            </div>
            <div class="status-field" data-cy="ar-payment-invoice-generator-status-field">
              <div class="date-header" data-cy="ar-payment-invoice-generator-status-label">Status: </div>
              <div class="date-data" data-cy="ar-payment-invoice-generator-status-value">{{ dataInvoiceItem.invoiceIsPaid ? 'Paid' : 'Unpaid' }} </div>
            </div>
          </div>
          <mat-divider data-cy="ar-payment-invoice-generator-divider-2"></mat-divider>
          <div class="invoice-detail-field-container" data-cy="ar-payment-invoice-generator-detail-container">
            <div class="invoiced-to-field" data-cy="ar-payment-invoice-generator-invoiced-to">
              @if (dataInvoiceItem.showPatientName) {
                <div class="invoice-detail-header" data-cy="ar-payment-invoice-generator-patient-name-label">
                  Patient Name:
                </div>
              }
              @if (dataInvoiceItem.showPatientName) {
                <div class="invoice-detail-field" data-cy="ar-payment-invoice-generator-patient-name-value">
                  {{ dataInvoiceItem.patientName }}
                </div>
              }
              @if (dataInvoiceItem.showBillableName) {
                <div class="invoice-detail-header" data-cy="ar-payment-invoice-generator-billable-name-label">
                  Invoiced To:
                </div>
              }
              @if (dataInvoiceItem.showBillableName) {
                <div class="invoice-detail-field" data-cy="ar-payment-invoice-generator-billable-name-value">
                  {{ dataInvoiceItem.billableName }}
                </div>
              }
            </div>
            <div class="pay-to-field" data-cy="ar-payment-invoice-generator-pay-to">
              <div class="invoice-detail-header" data-cy="ar-payment-invoice-generator-pay-to-label">
                Pay To:
              </div>
              <div class="invoice-detail-field" data-cy="ar-payment-invoice-generator-pay-to-name">
                {{ dataInvoiceItem.payToName }}
              </div>
              <div class="invoice-detail-field" data-cy="ar-payment-invoice-generator-pay-to-address1">
                {{ dataInvoiceItem.payToAddress1 }}
              </div>
              <div class="invoice-detail-field" data-cy="ar-payment-invoice-generator-pay-to-address2">
                {{ dataInvoiceItem.payToAddress2 }}
              </div>
            </div>
          </div>
          <mat-divider data-cy="ar-payment-invoice-generator-divider-3"></mat-divider>
          <div class="services-container" data-cy="ar-payment-invoice-generator-services-container">
            @for (columnHeader of dataInvoiceItem.columns; track columnHeader; let colIndex = $index) {
              <div class="service-column" [class.hide-column]="!columnHeader.show"
                [attr.data-cy]="'ar-payment-invoice-generator-service-column-' + colIndex">
                <div class="column-header" data-cy="ar-payment-invoice-generator-column-header">
                  {{ columnHeader.title }}
                </div>
                @for (item of dataInvoiceItem.billableItems; track item; let itemIndex = $index) {
                  <div class="column-item-display-value" [class.hide-column]="!item.showItem"
                    [attr.data-cy]="'ar-payment-invoice-generator-item-' + itemIndex + '-' + colIndex">
                    @if (columnHeader.pipe === 'date') {
                      <div data-cy="ar-payment-invoice-generator-item-date">
                        {{ item[columnHeader.key] | date }}
                      </div>
                    }
                    @if (columnHeader.pipe === 'currency') {
                      <div data-cy="ar-payment-invoice-generator-item-currency">
                        {{ item[columnHeader.key] | currency }}
                      </div>
                    }
                    @if (columnHeader.pipe === 'trim') {
                      <div data-cy="ar-payment-invoice-generator-item-trim">
                        {{ trimName(item[columnHeader.key]) }}
                      </div>
                    }
                    @if (columnHeader.pipe === 'none') {
                      <div data-cy="ar-payment-invoice-generator-item-none">
                        {{ item[columnHeader.key] }}
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
          <mat-divider data-cy="ar-payment-invoice-generator-divider-4"></mat-divider>
          <div class="total-container" data-cy="ar-payment-invoice-generator-total-container">
            <div class="total-header" data-cy="ar-payment-invoice-generator-total-label">
              Total due:
            </div>
            <div class="total-data" data-cy="ar-payment-invoice-generator-total-value">
              {{ dataInvoiceItem.paymentAmount | currency }}
            </div>
          </div>
        </div>
      </div>
      @if (!patientMode && dataInvoiceItem.showInvoice) {
        <div class="form-container" data-cy="ar-payment-invoice-generator-published-container">
          <div class="invoice-saved-text" data-cy="ar-payment-invoice-generator-published-message">The invoice has been published and cannot be changed</div>
        </div>
      }
      @if (!patientMode && !dataInvoiceItem.showInvoice) {
        <div class="form-container" data-cy="ar-payment-invoice-generator-form-container">
          <div data-cy="ar-payment-invoice-generator-title-container">
            <mat-form-field data-cy="ar-payment-invoice-generator-title-field">
              <mat-label data-cy="ar-payment-invoice-generator-title-label">Title</mat-label>
              <input matInput [(ngModel)]="dataInvoiceItem.title" data-cy="ar-payment-invoice-generator-title-input">
            </mat-form-field>
          </div>
          <div data-cy="ar-payment-invoice-generator-date-container">
            <mat-form-field data-cy="ar-payment-invoice-generator-date-field">
              <mat-label data-cy="ar-payment-invoice-generator-date-label">Invoice Date</mat-label>
              <input matInput [matDatepicker]="invoiceDatePicker" [(ngModel)]="dataInvoiceItem.invoiceDate" data-cy="ar-payment-invoice-generator-date-input">
              <mat-datepicker-toggle matSuffix [for]="invoiceDatePicker" data-cy="ar-payment-invoice-generator-date-toggle"></mat-datepicker-toggle>
              <mat-datepicker #invoiceDatePicker data-cy="ar-payment-invoice-generator-date-picker"></mat-datepicker>
            </mat-form-field>
          </div>
          <div data-cy="ar-payment-invoice-generator-options-container">
            <mat-checkbox class="inline-checkbox" [(ngModel)]="dataInvoiceItem.showPatientName" data-cy="ar-payment-invoice-generator-show-patient-checkbox">Show patient name
            </mat-checkbox>
            <mat-checkbox class="inline-checkbox" [(ngModel)]="dataInvoiceItem.showBillableName" data-cy="ar-payment-invoice-generator-show-billable-checkbox">Show billed to name
            </mat-checkbox>
            <mat-checkbox class="inline-checkbox" [(ngModel)]="dataInvoiceItem.showImage" data-cy="ar-payment-invoice-generator-show-image-checkbox">Show Image </mat-checkbox>
            <mat-checkbox style="margin-left: 48px;" class="inline-checkbox" [(ngModel)]="alertPatient" data-cy="ar-payment-invoice-generator-alert-patient-checkbox">Send alert to patient
            </mat-checkbox>
            <div data-cy="ar-payment-invoice-generator-names-container">
              <mat-form-field class="inline-input" data-cy="ar-payment-invoice-generator-patient-name-field">
                <mat-label data-cy="ar-payment-invoice-generator-patient-name-label">Patient Name</mat-label>
                <input matInput [(ngModel)]="dataInvoiceItem.patientName" data-cy="ar-payment-invoice-generator-patient-name-input">
              </mat-form-field>
              <mat-form-field class="inline-input" data-cy="ar-payment-invoice-generator-billable-name-field">
                <mat-label data-cy="ar-payment-invoice-generator-billable-name-label">Billed to name</mat-label>
                <input matInput [(ngModel)]="dataInvoiceItem.billableName" data-cy="ar-payment-invoice-generator-billable-name-input">
              </mat-form-field>
            </div>
          </div>
          <div data-cy="ar-payment-invoice-generator-pay-to-container">
            <mat-form-field class="inline-input" data-cy="ar-payment-invoice-generator-pay-to-name-field">
              <mat-label data-cy="ar-payment-invoice-generator-pay-to-name-label">Pay to name</mat-label>
              <input matInput [(ngModel)]="dataInvoiceItem.payToName" data-cy="ar-payment-invoice-generator-pay-to-name-input">
            </mat-form-field>
            <mat-form-field class="inline-input" data-cy="ar-payment-invoice-generator-pay-to-address1-field">
              <mat-label data-cy="ar-payment-invoice-generator-pay-to-address1-label">Address Line 1</mat-label>
              <input matInput [(ngModel)]="dataInvoiceItem.payToAddress1" data-cy="ar-payment-invoice-generator-pay-to-address1-input">
            </mat-form-field>
            <mat-form-field class="inline-input" data-cy="ar-payment-invoice-generator-pay-to-address2-field">
              <mat-label data-cy="ar-payment-invoice-generator-pay-to-address2-label">Address Line 2</mat-label>
              <input matInput [(ngModel)]="dataInvoiceItem.payToAddress2" data-cy="ar-payment-invoice-generator-pay-to-address2-input">
            </mat-form-field>
          </div>
          <div data-cy="ar-payment-invoice-generator-items-container">
            <h4 data-cy="ar-payment-invoice-generator-items-header">Invoice items</h4>
            @for (item of dataInvoiceItem.billableItems; track item; let i = $index) {
              <div class="invoice-form-item" [attr.data-cy]="'ar-payment-invoice-generator-form-item-' + i">
                <mat-divider data-cy="ar-payment-invoice-generator-item-divider"></mat-divider>
                <div data-cy="ar-payment-invoice-generator-service-name-container">
                  <mat-form-field class="inline-input" data-cy="ar-payment-invoice-generator-service-name-field">
                    <mat-label data-cy="ar-payment-invoice-generator-service-name-label">Service Name</mat-label>
                    <input matInput [(ngModel)]="item.serviceName" data-cy="ar-payment-invoice-generator-service-name-input">
                  </mat-form-field>
                </div>
                <div data-cy="ar-payment-invoice-generator-service-details-container">
                  <mat-form-field class="inline-input" data-cy="ar-payment-invoice-generator-service-date-field">
                    <mat-label data-cy="ar-payment-invoice-generator-service-date-label">Service Date</mat-label>
                    <input matInput [matDatepicker]="i" [(ngModel)]="item.serviceDate" data-cy="ar-payment-invoice-generator-service-date-input">
                    <mat-datepicker-toggle matSuffix [for]="i" data-cy="ar-payment-invoice-generator-service-date-toggle"></mat-datepicker-toggle>
                    <mat-datepicker #i data-cy="ar-payment-invoice-generator-service-date-picker"></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field class="inline-input" data-cy="ar-payment-invoice-generator-service-code-field">
                    <mat-label data-cy="ar-payment-invoice-generator-service-code-label">Service Code</mat-label>
                    <input matInput [(ngModel)]="item.serviceCode" data-cy="ar-payment-invoice-generator-service-code-input">
                  </mat-form-field>
                </div>
              </div>
            }
          </div>
        </div>
      }
      @if (!patientMode) {
        <div class="action-container" data-cy="ar-payment-invoice-generator-actions">
          <button mat-button color="warn" class="action-button" (click)="close()" data-cy="ar-payment-invoice-generator-cancel-btn">Cancel</button>
          <button mat-raised-button color="primary" class="action-button" [disabled]="generatingPdf"
            (click)="generatePDF()" data-cy="ar-payment-invoice-generator-pdf-btn">
            <i class="material-icons" data-cy="ar-payment-invoice-generator-pdf-icon">picture_as_pdf</i>
          </button>
          <button mat-raised-button color="primary" class="action-button" [disabled]="dataInvoiceItem.showInvoice"
          (click)="setupInvoiceObject()" data-cy="ar-payment-invoice-generator-reset-btn">Reset Invoice</button>
          <button mat-raised-button color="primary" class="action-button" [disabled]="dataInvoiceItem.showInvoice"
          (click)="saveInvoice()" data-cy="ar-payment-invoice-generator-publish-btn">Publish Invoice</button>
        </div>
      }
    </div>
  }

  @if (isLoading) {
    <div class="spinner-container" data-cy="ar-payment-invoice-generator-loading">
      <mat-spinner data-cy="ar-payment-invoice-generator-spinner"></mat-spinner>
    </div>
  }